<template>
  <section class="delete-event-user">
    <p class="delete-event-user__title">
      {{ $t('CP.confirmDeleteUser') }}
    </p>
    <div class="form-buttons">
      <button-app
        class="form-button_cancel"
        color-scheme="gray"
        type="submit"
        @clicked="$bvModal.hide('delete-event-user')"
      >
        {{ $t('CP.noCancelExclude') }}
      </button-app>
      <button-app
        class="form-button_save"
        type="button"
        @clicked="handleSubmit"
      >
        {{ $t('CP.yesExclude') }}
      </button-app>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex';
import { CLEAR_USER_TO_DELETE, UPDATE_EVENT_REQUEST } from '@/store/events/types';
import ButtonApp from '../../components/Button/ButtonApp';

export default {
  name: 'AddEventForm',
  components: {
    ButtonApp,
  },
  methods: {
    async handleSubmit() {
      await this.$store.dispatch(UPDATE_EVENT_REQUEST, {
        id: this.event.id,
        data: {
          event_name: this.event.event_name,
          edit_contact: { phone: this.userToDelete, act: 'delete' },
        },
      });
      this.$store.commit(CLEAR_USER_TO_DELETE);
      this.$bvModal.hide('delete-event-user');
    },
  },
  computed: {
    ...mapState({
      event: (state) => state.events.event,
      userToDelete: (state) => state.events.userToDelete,
    }),
  },
};
</script>

<style lang="scss" scoped>
  .delete-event-user {
    text-align: center;
  }
  .delete-event-user__title {
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 17px;
    text-align: center;
    letter-spacing: -0.08px;
    color: var(--text-main-color);
    margin-bottom: 24px;
  }
  .form-buttons {
    display: flex;
    justify-content: center;
  }
  .form-button_cancel {
    width: 160px;
    margin: 0 8px 0 0;
    font-style: normal;
    font-weight: 600;
    font-size: 13px;
    line-height: 22px;
  }
  .form-button_save {
    margin: 0;
    width: 160px;
    height: 38px;
    font-style: normal;
    font-weight: 600;
    font-size: 13px;
    line-height: 22px;
  }
</style>
